export enum TIMER_EVENTS {
  STOP = 'stop',
}
